import cityJSON from "@/assets/city.json";
export const getAreCodeByName = (name) => {
    if(!name) {
        return [cityJSON['features'][0]]
    }
    return cityJSON['features'].filter(ele => {
        return ele.properties.name === name;
    })
}